export var CalendarCellStatusProp = /*#__PURE__*/function (CalendarCellStatusProp) {
  CalendarCellStatusProp["Normal"] = "Normal";
  CalendarCellStatusProp["Block"] = "Block";
  return CalendarCellStatusProp;
}({});
export var CalendarType = /*#__PURE__*/function (CalendarType) {
  CalendarType["Day"] = "Day";
  CalendarType["Month"] = "Month";
  return CalendarType;
}({});